import { ISitePreferences } from '@/types/common/preferences';
import { camelCase, range, upperFirst } from 'lodash';
import packageJSON from '../../package.json';

export const X_HOST: string = process.env.REACT_APP_X_HOST || window.location.host.replace(/^.*?\./, '');

// Default preferences
export const INITIAL_PREFERENCES: ISitePreferences = {
  assets: {
    logo: `https://${X_HOST}/static/img/logo.svg`,
    favicon: '',
  },
  theme: {},
  site: {
    trackingId: '', // G-XXXXXXXXXX
    conversionLabelId: '', // 'AW-XXXXXXXXX/XxXxXxXxXxXxXxXxXxXxXx'
    url: X_HOST,
    name: `${upperFirst(camelCase(X_HOST))} App`,
    chatToken: '',
  },
};

export const IS_DEV = process.env.NODE_ENV === 'development';

// Sync with <title> from index.html
export const SITE_NAME = `Customer Dashboard • ${process.env.REACT_APP_SITENAME || 'App'}`;

// Track app version
export const APP_VERSION: string = packageJSON.version; // show version

// API base url
export const API_BASE_URL: string = process.env.REACT_APP_API_CUSTOMER_URL || `https://api.${X_HOST}`;

// DATE ISO FORMAT
export const DATE_FORMAT_DEADLINE_PICKER = 'MMM DD, YYYY [at] h A';
export const DATE_FORMAT_DEFAULT = 'MMMM D, YYYY, h:mm:ss A';

export const DATE_FORMAT_ISO = 'YYYY-MM-DD HH:mm:ss';

export const FILE_CARD_DATE = 'MMM D, YYYY, h:mm A';
export const SERVER_TIME_FORMAT = 'HH:mm:ss';
export const TIME_FORMAT = 'h:mm A';

// Deadline
const WEEK = 168; // hrs
const MONTH = 720;
// Most popular templates (hrs)
export const URGENCY_TEMPLATES: number[] = [3, 6, 12, 24, 48, 72, 96, 120, 144, WEEK, 240, WEEK * 2, WEEK * 3, MONTH, MONTH * 1.5];

// PAGINATION
export const PAGE_SIZE_OPTIONS = range(1, 101);

// FILES

export const ALLOWED_IMAGES = ['.jpeg', '.png', '.gif', '.jpg'];

export const ALLOWED_EXTENSIONS = [
  ...ALLOWED_IMAGES,
  '.txt',
  '.zip',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.rtf',
  '.ppt',
  '.pptx',
  '.csv',
  '.pdf',
  '.odt',
  '.html',
];

export const UPLOAD_ACCEPT_FILES = ALLOWED_EXTENSIONS.join(',');
export const UPLOAD_IMAGE_FILES = ALLOWED_IMAGES.join(',');

// !!! Sync with _cssVariables.less
export const THEME_COLORS: string[] = [
  'brand',
  'brand-content',
  'cta-button-content',
  'text-main',
  'text-heading',
  'text-alt',
  'text-input',
  'text-muted',
  'site-bg',
  'header-bg',
  'widget-bg',
  'widget-bg-alt',
  'disabled-bg',
  'muted',
  'link',
  'success',
  'warning',
  'processing',
  'unable',
  'danger',
  'error',
  'untouched-status',
  'claimed-status',
  'draft-status',
  'not-imposed-status',
  'pending-status',
  'in-work-status',
  'up-for-grabs-status',
  'completed-status',
  'submitted-status',
  'ready-status',
  'resolved-status',
  'aborted-status',
  'removed-status',
  'unable-to-commence-status',
  'unable-to-proceed-status',
  'withdrawn-status',
  'declined-status',
  'disputed-status',
  'canceled-status',
  'customer',
  'writer',
  'support',
];

export const isMac = !!navigator.platform.match(/mac/gi);

export const USER_DATA_KEY: 'customer' | 'writer' | 'author' = 'customer'; // for messenger

export const DEFAULT_POOLING_INTERVAL = 60000;

export const IS_DEV_ENV = process.env.NODE_ENV === 'development';

export const ORDER_SUBMIT_MESSAGE = 'An unexpected error occurred, please contact support team';

export const SENTRY_DSN = 'https://c5c02323071f4cd58d15f1462e6f967d@o1028159.ingest.sentry.io/4504646552977408';

export const AI_SURVEY_DISCOUNT = 'AISURVEY';

export const PREMIUM_WRITER_MIN_PRICE = 150;
